import { jwtDecode } from '../../utils/jwt'
import { isEqual } from 'lodash'
import { createContext, useContext, useEffect, useState } from 'react'
import {
	COOKIE_NAME_SALES_AGENT_JWT,
	COOKIE_NAME_SALES_AGENT_GROUP,
	SALES_AGENT_GROUP_NOT_LOGGED_IN,
	SALES_AGENT_GUEST,
} from '../../constants'
import { useCookiesByGroup } from '../../hooks/useCookiesByGroup'
import { useMemoCompare } from '../../hooks/useMemoCompare'
import { useConfig } from '../config'

const SalesAgentDataContext = createContext()

const SalesAgentDataProvider = ({ salesAgentAuthenticated, salesAgentGroup, children }) => {
	const { salesAgent: { enabled } = {} } = useConfig()

	const [salesAgent, setSalesAgent] = useState({
		isLoggedIn: salesAgentAuthenticated,
		groupId: salesAgentGroup ?? SALES_AGENT_GROUP_NOT_LOGGED_IN,
	})

	const [
		{
			[COOKIE_NAME_SALES_AGENT_GROUP]: cookieSalesAgentGroupValue,
			[COOKIE_NAME_SALES_AGENT_JWT]: cookieSalesAgentJwtValue,
		},
	] = useCookiesByGroup([COOKIE_NAME_SALES_AGENT_JWT, COOKIE_NAME_SALES_AGENT_GROUP])

	const cookieSalesAgentGroup = cookieSalesAgentGroupValue && parseInt(cookieSalesAgentGroupValue)

	useEffect(() => {
		if (
			(cookieSalesAgentJwtValue === undefined &&
				cookieSalesAgentGroup === undefined &&
				!isEqual(salesAgent, SALES_AGENT_GUEST)) ||
			(!enabled && !isEqual(salesAgent, SALES_AGENT_GUEST))
		) {
			// when cookies are undefined or salesAgent disabled we set guest sales agent
			setSalesAgent(SALES_AGENT_GUEST) // use same reference across renders
		} else if (cookieSalesAgentGroup !== undefined && cookieSalesAgentGroup !== salesAgent.groupId) {
			setSalesAgent({
				isLoggedIn:
					!!cookieSalesAgentJwtValue &&
					jwtDecode(cookieSalesAgentJwtValue)?.aud?.includes('admin') &&
					cookieSalesAgentGroup !== SALES_AGENT_GROUP_NOT_LOGGED_IN,
				groupId: cookieSalesAgentGroup,
			})
		}
	}, [cookieSalesAgentGroup, cookieSalesAgentJwtValue, salesAgent, enabled])

	const value = useMemoCompare(salesAgent, isEqual)

	return <SalesAgentDataContext.Provider value={value}>{children}</SalesAgentDataContext.Provider>
}

export default SalesAgentDataProvider
export const useSalesAgentData = () => useContext(SalesAgentDataContext)
